import ModalResolve from "./ModalResolve";

export default ModalResolve;
